import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import reportTemplateColumns from "./ReportTemplateColumns";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import ApiService from "../../../core/service/api-service";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {Button, Space} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import ReportTemplateCreateEditForm from "../ReportTemplateCreateEditForm";
import {useModal} from "../../../core/context/ModalContext";

export default function ReportTemplateGrid({})
{
    const {t} = useTranslation();
    const {setDataGridProps, queryModel, setData, setPaginationResult} = useDataGrid();
    const {openModal} = useModal()

    const initGridData = async () => {
        const response = await ApiService.ReportTemplate.GetDataGrid(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel.updateKey])

    // Silinmemiş tüm şablonlar tek ZIP (şablon başına bir JSON, satırdaki tek indirmeyle aynı biçim).
    const downloadAll = async () => {
        const response = await ApiService.ReportTemplate.ExportZip()
        if (response.success)
            ApiService.downloadFile(response.data, response.fileName)
    }

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: reportTemplateColumns(t)
        })
    }, [])

    return (
        <>
            <DataGrid
                title={() => (
                    <Space>
                        <Button
                            size={'small'}
                            onClick={() => {
                                openModal(
                                    t('New Report Template'),
                                    <ReportTemplateCreateEditForm />,
                                    () => {}
                                )
                            }}
                        >
                            {t('New Report Template')}
                        </Button>
                        <Button size={'small'} icon={<DownloadOutlined />} onClick={downloadAll}>
                            {t('Download all (ZIP)')}
                        </Button>
                    </Space>
                )}
                name={'report-template'}
            />
        </>
    )
}
